/** This is used for CSS in JS such as Victory Chart themes that cannot use the font mixin. */
export const getRegularFontSize = (locale = 'en-US') => {
  if (locale === 'ja') {
    return 14;
  }
  return 16;
};

export const getVictoryLabelFontSize = (locale = 'en-US') => {
  if (locale === 'ja') {
    return 8;
  }
  return 10;
};
